"use client"

import { useEffect } from "react"

import { useAppDispatch } from "@/src/store/hooks"
import { authReady, hydrateAuth } from "@/src/store/slices/authSlice"
import type { IUser } from "@/src/interfaces/auth.interface"

/**
 * Restores the session from localStorage on first load, once. Login only
 * persists a token; the app has no cookie-based session, so without this a
 * hard refresh of any protected route would find `state.auth.user === null`
 * and bounce a genuinely logged-in user back to /login.
 *
 * Renders nothing — it exists purely to dispatch into the store on mount.
 */
export function AuthHydrator() {
    const dispatch = useAppDispatch()

    useEffect(() => {
        const token = localStorage.getItem("token")
        const rawUser = localStorage.getItem("user")

        if (token && rawUser) {
            try {
                const user = JSON.parse(rawUser) as IUser
                dispatch(hydrateAuth({ user, token }))
                return
            } catch {
                // Corrupted cache — fall through and clear it below.
            }
        }

        localStorage.removeItem("token")
        localStorage.removeItem("user")
        dispatch(authReady())
        // Runs once per app load — deliberately not re-run on dispatch identity.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null
}
